import { render, staticRenderFns } from "./ProjectDeclaration.vue?vue&type=template&id=6fbc4c35&scoped=true&"
import script from "./ProjectDeclaration.vue?vue&type=script&lang=js&"
export * from "./ProjectDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDeclaration.vue?vue&type=style&index=0&id=6fbc4c35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc4c35",
  null
  
)

export default component.exports